import React from 'react'
import Nav from '../components/Nav'
import Footer from '../components/Footer'
import MainImg from '../components/MainImg'
import AboutContaner from '../components/AboutContaner'
const about = () => {
  return (
    <div>
       <Nav/>
       <MainImg heading="ABOUT." text="I am a friendly Web Developer"/>
       <AboutContaner/>
      <Footer/>
    </div>
  )
}

export default about
